import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/config')({
  component: ConfigPage,
})

function ConfigPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-brand-dark">
      <div className="text-center">
        <h1 className="text-4xl font-display font-bold text-white mb-4">
          Configuration
        </h1>
        <p className="text-brand-gray-light font-body text-lg">
          Configuration page - Coming soon
        </p>
      </div>
    </div>
  )
}
